import clsx from 'clsx';
import styles from '../../RelatedParties.module.scss';
import { alertIconDisabled } from '../../../../../../assets/hostedassets';
import { ALERTS_UNAVAILABLE_TEXT } from '../../relatedParty_constants';

/** Greyed-out Alerts column for a Related Party row whose alerts AICA can't fetch. */
function DisabledAlertsCell() {
    return (
        <div className={clsx(styles.Alerts, styles.Alerts_Disabled)}>
            <img src={alertIconDisabled} alt="alert" className={styles.AlertsIcon} />
            <span>{ALERTS_UNAVAILABLE_TEXT}</span>
        </div>
    );
}

export default DisabledAlertsCell;
